import type { Params, BackgroundMode } from '../../lib/types';
import { ThresholdSlider } from './ThresholdSlider';
import { Pills, Slider } from './widgets';

interface Props {
  params: Params;
  histogram: number[];
  setParam: <K extends keyof Params>(k: K, v: Params[K]) => void;
}

export function CoreControls({ params, histogram, setParam }: Props) {
  return (
    <div className="space-y-3">
      {params.mode === 'bw'
        ? <ThresholdSlider params={params} histogram={histogram} setParam={setParam} />
        : <Slider label="Colors" min={2} max={16} step={1} value={params.colorCount} onChange={(v) => setParam('colorCount', v)} />}
      <Slider label="Smoothness" min={0} max={1.34} step={0.01} value={params.smoothness} onChange={(v) => setParam('smoothness', v)} />
      <Slider label="Speckle removal" min={0} max={64} step={1} value={params.speckle} onChange={(v) => setParam('speckle', v)} />
      <Pills<BackgroundMode>
        label="Background"
        value={params.background}
        options={[['keep', 'keep'], ['remove-white', 'remove white'], ['remove-transparent', 'remove transparent'], ['pick', 'pick']]}
        onChange={(v) => setParam('background', v)}
      />
      {params.background === 'pick' && (
        <input type="color" value={params.backgroundPick} onChange={(e) => setParam('backgroundPick', e.target.value)} />
      )}
    </div>
  );
}
